import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, Link, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { fetchDevices } from '../../actions/devices';
import { fetchProfiles } from '../../actions/profiles';
import { fetchEvents } from '../../actions/events';

import Profiles from './Profiles';
import Events from './Events';
import Visual from './Visual';
import ProfileDeviceSelect from './ProfileDeviceSelect';
import ScheduleDeviceSelect from './ScheduleDeviceSelect';
import EventShow from '../events/Show';
import Loading from '../layout/Loading';

class Organisation extends Component {
  componentDidMount() {
    this.fetchAll();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.organisationId !== this.props.match.params.organisationId) {
      this.fetchAll();
    }
  }

  fetchAll() {
    const { dispatch, match } = this.props;
    dispatch(fetchDevices(match.params.organisationId));
    dispatch(fetchProfiles(match.params.organisationId));
    // dispatch(fetchEvents(match.params.organisationId));
  }

  render() {
    const { match, loading, loadingMessage } = this.props;

    if(loading) {
      return <Loading text={loadingMessage} />
    }
    return (
      <TransitionGroup>
        <CSSTransition key={this.props.location.pathname.split('/')[3]}  timeout={1000} classNames="fade">
          <div>
            <Switch>
              <Route exact path="/organisations/:organisationId">
                <Redirect to={`/organisations/${match.params.organisationId}/profiles`} />
              </Route>
              <Route path="/organisations/:organisationId/profiles/:profileId/devices" component={ProfileDeviceSelect} />
              <Route path="/organisations/:organisationId/profiles/:profileId?" component={Profiles} />
              <Route path="/organisations/:organisationId/visual" component={Visual} />
              <Route path="/organisations/:organisationId/events/:eventId/schedules/:scheduleId/devices" component={ScheduleDeviceSelect} />
              <Route path="/organisations/:organisationId/events/:eventId/schedules/:scheduleId?" component={EventShow} />
              <Route path="/organisations/:organisationId/events" component={Events} />
            </Switch>
          </div>
        </CSSTransition>
      </TransitionGroup>
    )
  }
}

const getLoadingMessages = (fetchingDevices, fetchingProfiles, fetchingEvents) => {
  const messages = [];
  if(fetchingDevices) {
    messages.push("devices");
  }
  if(fetchingProfiles) {
    messages.push("profiles");
  }
  if(fetchingEvents) {
    messages.push("events");
  }
  return messages;
}

export default withRouter(connect(
  ({ organisations, devices, profiles, events }, { match }) => ({
    organisation: organisations.data.find(o => o.id === match.params.organisationId),
    loading: devices.fetching || profiles.fetching,// || events.fetching,
    loadingMessage: `Loading ${getLoadingMessages(devices.fetching, profiles.fetching, events.fetching).join(", ")}...`
  })
)(Organisation));



// WEBPACK FOOTER //
// ./src/components/pages/Organisation.js